import { render } from "./RegistroContadorView.vue?vue&type=template&id=0ea5a5d0"
import script from "./RegistroContadorView.vue?vue&type=script&lang=js"
export * from "./RegistroContadorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__